import { writePackageCartToCache } from "@/Apollo/hooks/package-cart/packageCartCache";
import { useDisplayCurrencyMutation } from "@/Apollo/hooks/useDisplayCurrencyMutation";
import mutationGQL from "@/Apollo/mutation/package-cart/clearPackageCart.graphql";
import {
  ClearPackageCartMutation,
  ClearPackageCartMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions } from "@apollo/client";

export const useClearPackageCart = (
  options?: MutationHookOptions<
    ClearPackageCartMutation,
    ClearPackageCartMutationVariables
  >
) => {
  return useDisplayCurrencyMutation(mutationGQL, {
    ...options,
    update(cache, result, updateOptions) {
      writePackageCartToCache(
        cache,
        result.data?.clearPackageCart,
        updateOptions.variables?.displayCurrency ?? undefined
      );
      options?.update?.(cache, result, updateOptions);
    },
  });
};
